import React, { Fragment, useContext, useState } from 'react'
import './Sidebar.css';
import { Box, Collapse, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, SwipeableDrawer, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PATHS, SIDEBAR_BACKGROUND_COLOR } from '../../../utils/constant';
import HomeIcon from '@mui/icons-material/Home';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import SettingsIcon from '@mui/icons-material/Settings';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaymentsIcon from '@mui/icons-material/Payments';
import InventoryIcon from '@mui/icons-material/Inventory';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
import BadgeIcon from '@mui/icons-material/Badge';
import CategoryIcon from '@mui/icons-material/Category';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import InputIcon from '@mui/icons-material/Input';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../contexts/AuthContext';
import { genId, getUserPrivilages } from '../../../utils/helpers';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PaymentIcon from '@mui/icons-material/Payment';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const Logo = styled('img', {
  name: 'MuiStat', // The component name
  slot: 'root', // The slot name
})(({ theme }) => ({
  width: 160,
  padding: '10px 10px 10px 10px',
  cursor: 'pointer'
}));

const ArrowIcon = styled('img', {
  name: 'MuiStat',
  slot: 'root',
})(({ theme }) => ({
  width: '20px',
  height: '20px',
}));

const StyledListedItems = styled(ListItemButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: 0
}));

const StyledListedHeading = styled(Typography)(({ theme }) => ({
  paddingBottom: '5px',
  paddingLeft: '20px',
  fontSize: '16px',
  fontWeight: '400'
}));

const StyledListedButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center'
}));

const StyledListedButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: '10px',
  color: 'white',
  ':hover': { backgroundColor: theme.palette.primary.main },
}));

const StyledListedText = styled(ListItemText)(({ theme }) => ({
  fontSize: '20px',
  fontStyle: 'normal',
  fontWeight: '400',
  letterSpacing: '0.08px',
  lineHeight: 'normal'
}));

interface IChildMenuItem {
  id: string;
  label: string;
  icon: React.JSX.Element;
  hide?: boolean;
}

interface IMenuItem {
  id: string;
  label: string;
  icon: React.JSX.Element;
  children?: IChildMenuItem[];
  hide?: boolean;
}

interface ISidbarMenu {
  id: string;
  label: string;
  items: IMenuItem[];
  hide?: boolean;
}

interface IMenuWithChildrenProps {
  handleClick: () => any,
  isOpen: Boolean,
  label: string,
  icon: React.JSX.Element;
  children: IChildMenuItem[]
}

interface IMenuItemProps {
  path: string;
  label: string;
  icon: React.JSX.Element;
}

interface ISidebarProps {
  mobile?: Boolean;
  isOpen?: Boolean;
  closeSidebar?: () => any
}

const GetSidebarMenu = (): ISidbarMenu[] => {
  const { user } = useContext(AuthContext)
  const isNotPVCUSer = user.centerId?.includes("VL")
  const privilages = getUserPrivilages(user)
  return [
    {
      id: 'main',
      label: 'Main',
      items: [
        // {
        //   id: PATHS.DASHBOARD,
        //   label: 'Dashboard',
        //   icon: <DashboardIcon />,
        // },
        {
          id: PATHS.CREATE_TRANSACTION,
          label: 'Create Transaction',
          hide: isNotPVCUSer,
          icon: <InputIcon />,
        },
      ]
    },
    {
      id: 'blotters',
      label: 'Blotters',
      items: [
        {
          id: PATHS.PVC_TRANSACTIONS,
          label: 'PVC Transactions',
          icon: <CompareArrowsIcon />,
          hide: isNotPVCUSer
        },
        // {
        //   id: 'transaction',
        //   label: 'Transactions',
        //   icon: <MoveDownIcon />,
        //   hide: isNotPVCUSer,
        //   children: [
        //     {
        //       id: PATHS.PHYSICAL_BLOTTER,
        //       label: 'Physical Blotter',
        //       icon: <MoveDownIcon />,
        //     },
        //     {
        //       id: PATHS.DELIVERY_BLOTTER,
        //       label: 'Delivery Blotter',
        //       icon: <MoveDownIcon />,
        //     },
        //     {
        //       id: PATHS.TRADE_BLOTTER,
        //       label: 'Trade Blotter',
        //       icon: <MoveDownIcon />,
        //     },
        //     {
        //       id: PATHS.TRANSFERS_BLOTTER,
        //       label: 'Transfers Blotter',
        //       icon: <MoveDownIcon />,
        //     },
        //     {
        //       id: PATHS.INBOUND_BLOTTER,
        //       label: 'Inbound Blotter',
        //       icon: <MoveDownIcon />,
        //     },
        //   ]
        // },
        // {
        //   id: 'paymentBilling',
        //   label: 'Payment / Billing',
        //   icon: <PaymentsIcon />,
        //   hide: isNotPVCUSer,
        //   children: [
        //     {
        //       id: PATHS.PAYMENT_BLOTTER,
        //       label: 'Payment Blotter',
        //       icon: <PaymentsIcon />,
        //     },
        //     {
        //       id: PATHS.BILLING_BLOTTER,
        //       label: 'Billing Blotter',
        //       icon: <PaymentsIcon />,
        //     },
        //   ]
        // },
        // {
        //   id: 'tradeBlotter',
        //   label: 'Trade Blotter',
        //   icon: <HomeIcon />,
        //   children: [
        //     {
        //       id: 'submenu',
        //       label: 'Submenu',
        //       icon: <HomeIcon />,
        //     },
        //   ]
        // },
        {
          id: 'inventory',
          label: 'Inventory',
          icon: <InventoryIcon />,
          children: [
            {
              id: PATHS.INVENTORY_REQUEST,
              label: 'Inventory Request',
              icon: <InventoryIcon />,
            },
            // {
            //   id: PATHS.TRANSFER_ORDER,
            //   label: 'Transfer Order',
            //   icon: <InventoryIcon />,
            // },
            // {
            //   id: PATHS.INVENTORY,
            //   label: 'Inventory',
            //   icon: <InventoryIcon />,
            // },
            {
              id: PATHS.INVENTORY_MANAGEMENT,
              label: 'Inventory Management - PVC',
              icon: <InventoryIcon />,
            },
          ]
        },
      ]
    },
    // {
    //   id: 'reports',
    //   label: 'Reports',
    //   hide: isNotPVCUSer,
    //   items: [
    //     {
    //       id: PATHS.REPORTS,
    //       label: 'Reports',
    //       icon: <ReceiptLongIcon />,
    //     },
    //   ]
    // },
    {
      id: 'masterDataManagement',
      label: 'Master Data Management',
      hide: isNotPVCUSer,
      items: [
        {
          id: 'masterDataSetup',
          label: 'Master Data Setup',
          icon: <ManageAccountsIcon />,
          children: [
            {
              id: PATHS.CUSTOMERS,
              label: 'Customer Setup',
              icon: <SettingsAccessibilityIcon />,
              hide: !privilages.customer.read
            },
            {
              id: PATHS.EMPLOYEES,
              label: 'Employee Setup',
              icon: <BadgeIcon />,
              hide: !privilages.customer.read
            }
            // {
            //   id: 'productMaster',
            //   label: 'Product Master',
            //   icon: <CategoryIcon />,
            // },
            // {
            //   id: 'productPremiumMaster',
            //   label: 'Product Premium Master',
            //   icon: <ProductionQuantityLimitsIcon />,
            // },
            // {
            //   id: PATHS.USER_MASTER,
            //   label: 'User Master',
            //   icon: <ManageAccountsIcon />,
            // },
            // {
            //   id: 'premiumMgmt',
            //   label: 'Premium Mgmt',
            //   icon: <WorkspacePremiumIcon />,
            // },
            // {
            //   id: 'userControls',
            //   label: 'User Controls',
            //   icon: <SupervisorAccountIcon />,
            // },
            // {
            //   id: 'inventory',
            //   label: 'Inventory',
            //   icon: <InventoryIcon />,
            // },
            // {
            //   id: 'businessParameter',
            //   label: 'Business Parameter',
            //   icon: <BusinessCenterIcon />,
            // },
          ]
        },
      ]
    },
    {
      id: 'reports',
      label: 'Reports',
      hide: isNotPVCUSer,
      items: [
        {
          id: 'reports',
          label: 'PVC Reports',
          icon: <AssessmentIcon />,
          children: [
            {
              id: PATHS.TRANSACTIONALREPORT,
              label: 'Transactional Report',
              icon: <ReceiptLongIcon />,
              hide: !privilages.customer.read
            },
            {
              id: PATHS.PAYMANTSREPORT,
              label: 'Payment Report',
              icon: <PaymentIcon />,
              hide: !privilages.customer.read
            },
            {
              id: PATHS.STOCKORDERSREPORT,
              label: 'PVC Stock Orders',
              icon: <InventoryIcon />,
              hide: !privilages.customer.read
            },
            {
              id: PATHS.STOCKAGEINGREPORT,
              label: 'Stock Ageing Report',
              icon: <AssessmentIcon />,
              hide: !privilages.customer.read
            },
            {
              id: PATHS.INVENTORYONHANDREPORT,
              label: 'Inventory On Hand',
              icon: <InventoryIcon />,
              hide: !privilages.customer.read
            },
           
            {
              id: PATHS.STOCKINREPORT,
              label: 'Stock-In Report',
              icon: <AssessmentIcon />,
              hide: !privilages.customer.read
            },
            {
              id: PATHS.STOCKOUTREPORT,
              label: 'Stock-Out Report',
              icon: <AssessmentIcon />,
              hide: !privilages.customer.read
            },
            {
              id: PATHS.SALESREPORT,
              label: 'Sales Report',
              icon: <MonetizationOnIcon />,
              hide: !privilages.customer.read
            },
            {
              id: PATHS.DOCUMENTREPORT,
              label: 'TI DC Summary Report',
              icon: <PointOfSaleIcon />,
              hide: !privilages.customer.read
            },
            {
              id: PATHS.STOCKREPORT,
              label: 'PVC Stock Report',
              icon: <AssessmentIcon />,
              hide: !privilages.customer.read
            },
            {
              id: PATHS.SKYCREPORT,
              label: 'SKYC Transaction Report',
              icon: <AssessmentIcon />,
              hide: !privilages.customer.read
            },
            // {
            //   id: 'productMaster',
            //   label: 'Product Master',
            //   icon: <CategoryIcon />,
            // },
            // {
            //   id: 'productPremiumMaster',
            //   label: 'Product Premium Master',
            //   icon: <ProductionQuantityLimitsIcon />,
            // },
            // {
            //   id: PATHS.USER_MASTER,
            //   label: 'User Master',
            //   icon: <ManageAccountsIcon />,
            // },
            // {
            //   id: 'premiumMgmt',
            //   label: 'Premium Mgmt',
            //   icon: <WorkspacePremiumIcon />,
            // },
            // {
            //   id: 'userControls',
            //   label: 'User Controls',
            //   icon: <SupervisorAccountIcon />,
            // },
            // {
            //   id: 'inventory',
            //   label: 'Inventory',
            //   icon: <InventoryIcon />,
            // },
            // {
            //   id: 'businessParameter',
            //   label: 'Business Parameter',
            //   icon: <BusinessCenterIcon />,
            // },
          ]
        },
      ]
    },
    // {
    //   id: 'admin',
    //   label: 'Admin',
    //   items: [
    //     {
    //       id: 'systemAdmin',
    //       label: 'System Admin',
    //       icon: <SettingsIcon />,
    //       children: [
    //         {
    //           id: 'admin',
    //           label: 'Admin',
    //           icon: <SettingsIcon />,
    //         },
    //       ]
    //     },
    //   ]
    // },
  ]
}

const MenuWithChildren = ({ handleClick, isOpen, label, children, icon }: IMenuWithChildrenProps) => {
  const navigate = useNavigate()

  return (
    <>
      <StyledListedItems onClick={handleClick}>
        <StyledListedButton>
          <ListItemIcon sx={{ color: '#fff', minWidth: 46 }}>
            {icon}
          </ListItemIcon>
          <ListItemText primary={label} />
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </StyledListedButton>
      </StyledListedItems>
      <Collapse in={Boolean(isOpen)} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children.map(childItem => {
            return childItem.hide
              ? (<Fragment key={genId()}></Fragment>)
              : (
                // <Link to={childItem.id} style={{ textDecoration: 'none' }} key={childItem.id}>
                <StyledListedItems sx={{ ml: 4 }} key={childItem.id} onClick={() => navigate(childItem.id)}>
                  <StyledListedButton>
                    <ListItemIcon sx={{ color: '#fff', minWidth: 46 }}>
                      {childItem.icon}
                    </ListItemIcon>
                    <ListItemText primary={childItem.label} />
                  </StyledListedButton>
                </StyledListedItems>
                // </Link>
              )
          })}
        </List>
      </Collapse>
    </>
  )
}

const MenuItem = ({ path, label, icon }: IMenuItemProps) => {
  const navigate = useNavigate()

  return (
    // <Link to={path} style={{ textDecoration: 'none' }} >
    <StyledListedItems onClick={() => navigate(path)}>
      <StyledListedButton>
        <ListItemIcon sx={{ color: '#fff', minWidth: 46 }}>
          {icon}
        </ListItemIcon>
        <ListItemText primary={label} />
      </StyledListedButton>
    </StyledListedItems>
    // </Link>
  )
}

const SidebarContent = () => {
  const [openMenu, setOpenMenu] = useState('');
  const navigate = useNavigate();

  const toggleMenu = (id: string) => {
    openMenu && openMenu === id ? setOpenMenu('') : setOpenMenu(id)
  }

  return (
    <>
      {/* Site Logo */}
      <Box className='box-container-logo' onClick={() => navigate(PATHS.DASHBOARD)}>
        <Logo src='/assets/icons/MMTC-PAMP-Logo-New.png' alt='logo' />
      </Box>

      <Box className='box-list-container'>
        {GetSidebarMenu().map(menu => {
          return (
            <>
            {!menu.hide &&
              <List key={menu.id}>
              <StyledListedHeading>{menu.label}</StyledListedHeading>
              {menu.items.map(menuItem => {
                return Boolean(!menuItem.hide) && Boolean(menuItem.children?.length) ?
                  <MenuWithChildren
                    isOpen={openMenu === menuItem.id}
                    handleClick={() => toggleMenu(menuItem.id)}
                    label={menuItem.label}
                    key={menuItem.id}
                    icon={menuItem.icon}
                    children={menuItem.children!}
                  /> :
                  Boolean(!menuItem.hide) &&
                  <MenuItem
                    path={menuItem.id}
                    label={menuItem.label}
                    key={menuItem.id}
                    icon={menuItem.icon}
                  />
              })}
            </List >
            }
            </>
          )
        })}
      </Box>
    </>
  )
}

const Sidebar = ({ mobile, isOpen, closeSidebar }: ISidebarProps) => {
  return mobile ? (
    <SwipeableDrawer open={Boolean(isOpen)} onClose={closeSidebar!} onOpen={() => { }} >
      <SidebarContent />
    </SwipeableDrawer>
  ) : (
    <Drawer variant='permanent' ModalProps={{ className: 'box-sidebar-main-container' }} PaperProps={{ style: { background: "var(--secondary_color)", width: '260px' } }} >
      <SidebarContent />
    </Drawer>
  )
}

export default Sidebar
